import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { CustomTableColumnType } from '../modals/enum/custom-table.enum'
import { ICustomTableColumn, ICustomTableHeader } from '../modals/interface/custom-table.interface'
import { CustomTableService } from '../service/custom-table.service'

@Component({
    selector: 'app-custom-table',
    templateUrl: './custom-table.component.html',
    styleUrls: ['./custom-table.component.scss'],
    standalone: false
})
export class CustomTableComponent implements OnInit, OnDestroy {
  @Input() override?: string
  @Input() rowId?: string
  @Input() showLoader?: boolean
  @Input() pagination?: any
  @Output() changePagination: EventEmitter<number> = new EventEmitter()
  @Output() changeValue: EventEmitter<number> = new EventEmitter()
  public dataSource: any
  public destroy$ = new Subject()

  constructor(private customTableService: CustomTableService) {}

  ngOnInit(): void {
    this.customTableService.clicked$.pipe(takeUntil(this.destroy$)).subscribe(({ control, row }) => {
      const uid = row[this.rowId]
      const data = this.dataSource[uid]
      control.handler(data)
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  public headerSource: ICustomTableHeader[]
  @Input() set headers(data: ICustomTableHeader[]) {
    this.headerSource = this.customTableService.getHeaders(data)
  }

  public columnSource: ICustomTableColumn[]
  @Input() set columns(data: ICustomTableColumn[]) {
    this.columnSource = this.customTableService.getColumns(data, this.headerSource)
  }

  public rowSource: any[]
  @Input() set rows(data: any[]) {
    if (!this.columnSource) {
      throw new Error('Need columns before rows.')
    }

    this.rowSource = this.customTableService.getRows(data, this.columnSource)
    this.dataSource = data.reduce((acc, item, i) => {
      const row = this.rowSource[i]
      const uid = row[this.rowId]
      acc[uid] = item
      return acc
    }, {})
    this.customTableService.dataSource = this.dataSource
  }

  public get EnumColumnType(): typeof CustomTableColumnType {
    return CustomTableColumnType
  }
}
